import { useState } from 'react';

import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';

export default function CreditCheckAuthorization({ applicantName, coApplicantName }) {
  const [creditToUse, setCreditToUse] = useState("applicant");

  return (
    <fieldset className="quoteform__creditcheckinfo">
      <div className="quoteform__heading quoteform__creditcheckinfo-heading">Credit Check Info</div>
      {coApplicantName && (
        <React.Fragment>
          <div className="quoteform__heading">Who would you like us to use for the credit check? *</div>
          <div className="quoteform__input quoteform__creditcheckinfo-select">
            <TextField select fullWidth variant="outlined" defaultValue="applicant" onChange={({ target: { value } }) => setCreditToUse(value)}>
              <MenuItem value="applicant">Primary Applicant<small>&emsp;{`${applicantName}`}</small></MenuItem>
              <MenuItem value="coapplicant">Co-Applicant<small>&emsp;{`${coApplicantName}`}</small></MenuItem>
              <MenuItem value="both">Both Applicants<small>&emsp;{`${applicantName} & ${coApplicantName}`}</small></MenuItem>
            </TextField>
          </div>
        </React.Fragment>
      )}
      <div className="quoteform__creditcheckinfo-columns">
        {"coapplicant" !== creditToUse && (
          <div className="quoteform__creditcheckinfo-column">
            {coApplicantName && (
              <legend className="quoteform__heading">{applicantName}</legend>
            )}
            <div className="quoteform__input">
              <TextField
                fullWidth
                required
                label="Social Security Number"
                variant="outlined"
                name="applicant-ssn"
              />
            </div>
            <div className="quoteform__input">
              <TextField
                type="date"
                fullWidth
                required
                label="Date of Birth"
                variant="outlined"
                name="applicant-dob"
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        )}
        {"applicant" !== creditToUse && (
          <div className="quoteform__creditcheckinfo-column">
            <legend className="quoteform__heading">{coApplicantName}</legend>
            <div className="quoteform__input">
              <TextField
                fullWidth
                required
                label="Social Security Number"
                variant="outlined"
                name="coapplicant-ssn"
              />
            </div>
            <div className="quoteform__input">
              <TextField
                type="date"
                fullWidth
                required
                label="Date of Birth"
                variant="outlined"
                name="coapplicant-dob"
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        )}
      </div>
      <div className="quoteform__heading">Authorization for credit check *</div>
      <FormControlLabel
        className="MuiCheckbox-root--alignstart"
        required
        label={(
          <div>
            By checking this box and clicking "Submit", I am signing this Credit Check Application electronically and authorizing Monera to run a credit check based on the information I have provided above. I understand that a hard credit hit will occur, and my credit report will be retrieved for the purpose of establishing the terms of financing. Monera will not run a new credit report if there is one on file from the last 90 days.
            <br/><br/>
            To prevent the possibility of information sharing by the credit bureaus, visit www.optoutprescreen.com or call the toll free number (888) 5-OPT OUT . This website is a joint venture among the three nationwide credit bureaus to allow consumers to control pre-screened offers.
          </div>
        )}
        control={
          <Checkbox
            color="primary"
            required
            value="yes"
            name="applicant-creditcheck"
          />
        }
      />
      <input type="hidden" name="applicant" value={creditToUse} />
    </fieldset>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/CreditCheckAuthorization.js